/* Settings area: properties, locations, commercial defaults, approval
 * workflows and finance coding. */
const settings = {
  // Page header & tabs
  'Properties': 'Properti',
  'Locations': 'Lokasi',
  'Organization defaults': 'Default organisasi',
  'Property overrides': 'Penggantian per properti',
  'Approval workflows': 'Alur kerja persetujuan',
  'Coding': 'Pengodean',
  'Commercial standards used across suppliers and purchasing. Configure organization defaults and optional per-property overrides.': 'Standar komersial yang digunakan di seluruh pemasok dan pembelian. Atur default organisasi dan penggantian per properti (opsional).',
  'Settings sections': 'Bagian pengaturan',
  'Could not load settings': 'Tidak dapat memuat pengaturan',
  'Could not load property settings': 'Tidak dapat memuat pengaturan properti',
  'Organization defaults saved': 'Default organisasi disimpan',
  'Could not save settings': 'Tidak dapat menyimpan pengaturan',
  'Property overrides saved': 'Penggantian properti disimpan',
  'Could not save overrides': 'Tidak dapat menyimpan penggantian',
  'Properties sync from Prostay and TableView. Once a property exists here, you can override the organization commercial defaults for it.': 'Properti disinkronkan dari Prostay dan TableView. Setelah sebuah properti ada di sini, Anda dapat mengganti default komersial organisasi untuknya.',
  'Select a property…': 'Pilih properti…',
  'Choose a property to view or override its commercial standards. Sections left as “inherit” use the organization defaults.': 'Pilih properti untuk melihat atau mengganti standar komersialnya. Bagian yang dibiarkan sebagai “mewarisi” menggunakan default organisasi.',

  // Properties tab
  'Hotels, resorts and venues in this organization. Not every property needs a Prostay or TableView integration.': 'Hotel, resor, dan venue di organisasi ini. Tidak semua properti memerlukan integrasi Prostay atau TableView.',
  'Add property': 'Tambah properti',
  'Create your first property to enable per-property settings and scoping.': 'Buat properti pertama Anda untuk mengaktifkan pengaturan dan pencakupan per properti.',
  'Linked': 'Tertaut',
  'Standalone': 'Mandiri',
  'Edit property': 'Ubah properti',
  'Property name': 'Nama properti',
  'Name is required.': 'Nama wajib diisi.',
  'Base currency': 'Mata uang dasar',
  'Timezone': 'Zona waktu',
  'Prostay / TableView property ID': 'ID properti Prostay / TableView',
  'Optional — leave blank for a standalone property with no PMS integration.': 'Opsional — biarkan kosong untuk properti mandiri tanpa integrasi PMS.',
  'Create property': 'Buat properti',
  'Property updated': 'Properti diperbarui',
  'Property created': 'Properti dibuat',
  'Could not update property': 'Tidak dapat memperbarui properti',
  'Could not create property': 'Tidak dapat membuat properti',

  // Locations tab
  'New location': 'Lokasi baru',
  'No locations yet': 'Belum ada lokasi',
  'Add storage locations (warehouses, walk-ins, bars, kitchens). Inventory and par levels are tracked per location.': 'Tambahkan lokasi penyimpanan (gudang, walk-in, bar, dapur). Inventaris dan level par dilacak per lokasi.',
  'Organization-wide': 'Seluruh organisasi',
  '— Organization-wide —': '— Seluruh organisasi —',
  'Edit location': 'Ubah lokasi',
  'Delete location': 'Hapus lokasi',
  'Create location': 'Buat lokasi',
  'Location updated': 'Lokasi diperbarui',
  'Location created': 'Lokasi dibuat',
  'Location deleted': 'Lokasi dihapus',
  'Could not load locations': 'Tidak dapat memuat lokasi',
  'Could not save location': 'Tidak dapat menyimpan lokasi',
  'Could not delete location': 'Tidak dapat menghapus lokasi',
  'Delete "{name}"?': 'Hapus "{name}"?',
  'Main Warehouse': 'Gudang Utama',
  // Location kinds (labels live in catalogApi's LOCATION_KINDS)
  'Store room': 'Ruang penyimpanan',
  'Warehouse': 'Gudang',
  'Kitchen': 'Dapur',
  'Bar': 'Bar',
  'Outlet': 'Outlet',
  'Cellar': 'Gudang anggur',
  'Other': 'Lainnya',

  // Commercial terms form
  'Currencies': 'Mata uang',
  'Currencies suppliers can transact in. One is the default.': 'Mata uang yang dapat digunakan pemasok untuk bertransaksi. Salah satunya menjadi default.',
  'Override': 'Ganti',
  'Inherits the organization currencies.': 'Mewarisi mata uang organisasi.',
  'Add a currency…': 'Tambah mata uang…',
  'Add currency': 'Tambah mata uang',
  'No currencies added yet.': 'Belum ada mata uang yang ditambahkan.',
  'Default currency': 'Mata uang default',
  'Set as default': 'Jadikan default',
  'Number format': 'Format angka',
  'How amounts are displayed everywhere — decimal and thousands separators.': 'Cara jumlah ditampilkan di mana pun — pemisah desimal dan ribuan.',
  'Payment terms': 'Syarat pembayaran',
  'Named terms (e.g. Net 30) with the number of days until due.': 'Syarat bernama (mis. Net 30) dengan jumlah hari hingga jatuh tempo.',
  'Inherits the organization payment terms.': 'Mewarisi syarat pembayaran organisasi.',
  'Term name': 'Nama syarat',
  'Days': 'Hari',
  'Default': 'Default',
  'Set default': 'Atur default',
  'Remove term': 'Hapus syarat',
  'Add term': 'Tambah syarat',
  'Payment methods': 'Metode pembayaran',
  'How invoices to suppliers are typically settled.': 'Cara faktur kepada pemasok biasanya diselesaikan.',
  'Inherits the organization payment methods.': 'Mewarisi metode pembayaran organisasi.',
  'Bank transfer': 'Transfer bank',
  'Method name': 'Nama metode',
  'Remove method': 'Hapus metode',
  'Add method': 'Tambah metode',

  // Approval workflows
  'Purchase orders': 'Pesanan pembelian',
  'Supplier invoices': 'Faktur pemasok',
  'Could not load approval settings': 'Tidak dapat memuat pengaturan persetujuan',
  'Could not load property approval settings': 'Tidak dapat memuat pengaturan persetujuan properti',
  'Approval workflows saved': 'Alur kerja persetujuan disimpan',
  'Could not save workflows': 'Tidak dapat menyimpan alur kerja',
  'Property approval overrides saved': 'Penggantian persetujuan properti disimpan',
  'Once a property exists, you can override the organization approval workflows for it.': 'Setelah sebuah properti ada, Anda dapat mengganti alur kerja persetujuan organisasi untuknya.',
  'Choose a property to override its approval workflows. Left as inherit, it uses the organization defaults.': 'Pilih properti untuk mengganti alur kerja persetujuannya. Jika dibiarkan mewarisi, properti menggunakan default organisasi.',
  'Select a role…': 'Pilih peran…',
  'Organization admins (default)': 'Admin organisasi (default)',
  'Steps apply cumulatively, in order. A document requires every step whose threshold is at or below its total.': 'Langkah berlaku kumulatif, sesuai urutan. Dokumen memerlukan setiap langkah yang ambangnya berada pada atau di bawah totalnya.',
  'A price or quantity variance forces the full chain regardless of amount.': 'Selisih harga atau kuantitas mewajibkan seluruh rantai persetujuan berapa pun jumlahnya.',
  'No approval steps — a single approval by anyone with the {permission} permission is required.': 'Tidak ada langkah persetujuan — cukup satu persetujuan oleh siapa pun yang memiliki izin {permission}.',
  'Approver role': 'Peran penyetuju',
  'This role lacks the {permission} permission.': 'Peran ini tidak memiliki izin {permission}.',
  'Minimum amount': 'Jumlah minimum',
  'Remove step': 'Hapus langkah',
  'Add step': 'Tambah langkah',
  'Threshold currency': 'Mata uang ambang',
  'Allow self-approval': 'Izinkan persetujuan sendiri',
  'Admins can approve any step': 'Admin dapat menyetujui langkah apa pun',
  'Reminders re-nudge the pending approvers; escalation also notifies the escalation target (the approval still needs the right role to act). Leave hours blank to disable.': 'Pengingat menegur kembali penyetuju yang tertunda; eskalasi juga memberi tahu target eskalasi (persetujuan tetap memerlukan peran yang tepat untuk bertindak). Kosongkan jam untuk menonaktifkan.',
  'Reminder after (hours)': 'Pengingat setelah (jam)',
  'Reminder after hours': 'Pengingat setelah sekian jam',
  'Escalate after (hours)': 'Eskalasi setelah (jam)',
  'Escalate after hours': 'Eskalasi setelah sekian jam',
  'Escalation target': 'Target eskalasi',
  'Escalation target role': 'Peran target eskalasi',
  'Off': 'Nonaktif',
  'No roles found. Create roles under Users & Roles before configuring approval steps.': 'Tidak ada peran ditemukan. Buat peran di Pengguna & Peran sebelum mengatur langkah persetujuan.',
  'Approval emails': 'Email persetujuan',
  'Master switch for all approval notifications (action-needed, reminders, escalation, decisions). Individual users can still opt out in My Account.': 'Sakelar utama untuk semua notifikasi persetujuan (perlu tindakan, pengingat, eskalasi, keputusan). Setiap pengguna tetap dapat memilih keluar di Akun saya.',
  'Send approval emails': 'Kirim email persetujuan',
  'Property override': 'Penggantian properti',
  'When off, this property inherits the organization approval workflows.': 'Saat nonaktif, properti ini mewarisi alur kerja persetujuan organisasi.',
  'Inherits the organization approval workflows.': 'Mewarisi alur kerja persetujuan organisasi.',

  // Requisitions tab
  'Requisitions': 'Permintaan',
  'Requisition rules saved': 'Aturan permintaan disimpan',
  'Supporting file on requisitions': 'Berkas pendukung pada permintaan',
  'When on, a requisition must carry at least one file — a photo of the item, a supplier quote or a specification — before it can be submitted for approval. Any file type counts, so approvers are never asked to decide with nothing to look at.':
    'Saat aktif, permintaan wajib memiliki setidaknya satu berkas — foto barang, penawaran pemasok, atau spesifikasi — sebelum dapat diajukan untuk persetujuan. Semua jenis berkas dihitung, sehingga penyetuju tidak pernah diminta memutuskan tanpa bahan.',
  'Require a file before a requisition can be submitted': 'Wajibkan berkas sebelum permintaan dapat diajukan',
  'Upload size limit': 'Batas ukuran unggahan',
  'The largest single file anyone can upload, anywhere in the system — requisition files, receiving photos, invoice scans, supplier documents and catalogue images. Applies to the whole organization.':
    'Berkas tunggal terbesar yang dapat diunggah siapa pun, di mana pun dalam sistem — berkas permintaan, foto penerimaan, pindaian faktur, dokumen pemasok, dan gambar katalog. Berlaku untuk seluruh organisasi.',
  'Maximum file size (MB)': 'Ukuran berkas maksimum (MB)',
  'Default: {n} MB': 'Default: {n} MB',
  'Enter an upload limit between 1 and 200 MB.': 'Masukkan batas unggahan antara 1 dan 200 MB.',
  'Once a property exists, you can override the organization requisition rules for it.':
    'Setelah properti ada, Anda dapat mengganti aturan permintaan organisasi untuk properti tersebut.',
  'Choose a property to override its requisition rules. Left as inherit, it uses the organization defaults.':
    'Pilih properti untuk mengganti aturan permintaannya. Jika dibiarkan mewarisi, properti menggunakan default organisasi.',
  'When off, this property inherits the organization requisition rules.':
    'Saat nonaktif, properti ini mewarisi aturan permintaan organisasi.',
  'Inherits the organization requisition rules.': 'Mewarisi aturan permintaan organisasi.',
  'The upload size limit is organization-wide and cannot be overridden per property.':
    'Batas ukuran unggahan berlaku untuk seluruh organisasi dan tidak dapat diganti per properti.',

  // Receiving tab
  'Receiving rules saved': 'Aturan penerimaan disimpan',
  'Photo evidence on receiving': 'Bukti foto saat penerimaan',
  'When on, the store keeper must attach a photo to every line with an accepted or rejected quantity before a goods receipt can be posted. Rejections get documented and deliveries are verifiable.':
    'Saat aktif, petugas gudang wajib melampirkan foto pada setiap baris dengan kuantitas diterima atau ditolak sebelum penerimaan barang dapat diposting. Penolakan terdokumentasi dan kiriman dapat diverifikasi.',
  'Require a photo for every received line': 'Wajibkan foto untuk setiap baris yang diterima',
  'Once a property exists, you can override the organization receiving rules for it.':
    'Setelah properti ada, Anda dapat mengganti aturan penerimaan organisasi untuk properti tersebut.',
  'Choose a property to override its receiving rules. Left as inherit, it uses the organization defaults.':
    'Pilih properti untuk mengganti aturan penerimaannya. Jika dibiarkan mewarisi, properti menggunakan default organisasi.',
  'When off, this property inherits the organization receiving rules.':
    'Saat nonaktif, properti ini mewarisi aturan penerimaan organisasi.',
  'Inherits the organization receiving rules.': 'Mewarisi aturan penerimaan organisasi.',

  // Invoice matching tab
  'Invoice matching': 'Pencocokan faktur',
  'Three-way match tolerances': 'Toleransi pencocokan tiga arah',
  'Every invoice is checked against what was ordered (PO price) and what was received (goods receipts). Differences within these tolerances still count as a match; anything beyond gets flagged as a variance and forces the full invoice approval chain.':
    'Setiap faktur diperiksa terhadap apa yang dipesan (harga PO) dan apa yang diterima (penerimaan barang). Selisih dalam batas toleransi ini tetap dianggap cocok; selebihnya ditandai sebagai varian dan mewajibkan rantai persetujuan faktur penuh.',
  'Price tolerance (%)': 'Toleransi harga (%)',
  'Quantity tolerance (%)': 'Toleransi kuantitas (%)',
  'Default: {n}%': 'Default: {n}%',
  'Default: {n}% (exact)': 'Default: {n}% (persis)',
  'Billed unit price may differ from the PO price by up to this much.': 'Harga satuan yang ditagih boleh berbeda dari harga PO hingga sebesar ini.',
  'Billed quantity may differ from the received quantity by up to this much.': 'Kuantitas yang ditagih boleh berbeda dari kuantitas diterima hingga sebesar ini.',
  'Match tolerances saved': 'Toleransi pencocokan disimpan',
  'Once a property exists, you can override the organization match tolerances for it.':
    'Setelah properti ada, Anda dapat mengganti toleransi pencocokan organisasi untuk properti tersebut.',
  'Choose a property to override its match tolerances. Left as inherit, it uses the organization defaults.':
    'Pilih properti untuk mengganti toleransi pencocokannya. Jika dibiarkan mewarisi, properti menggunakan default organisasi.',
  'When off, this property inherits the organization match tolerances.':
    'Saat nonaktif, properti ini mewarisi toleransi pencocokan organisasi.',
  'Inherits the organization match tolerances.': 'Mewarisi toleransi pencocokan organisasi.',

  // Coding tab
  'Cost centres': 'Pusat biaya',
  'Departments / outlets that spend is attributed to. Used for coding and budgets.': 'Departemen / outlet tempat pengeluaran dibebankan. Digunakan untuk pengodean dan anggaran.',
  'GL accounts': 'Akun GL',
  'Chart of expense accounts document lines can post to.': 'Bagan akun beban tempat baris dokumen dapat dibukukan.',
  'None yet. Add one below.': 'Belum ada. Tambahkan satu di bawah.',
  'Code': 'Kode',
  'Add cost centre': 'Tambah pusat biaya',
  'Add GL account': 'Tambah akun GL',
  'Coding chart saved': 'Bagan pengodean disimpan',
  'Could not load coding settings': 'Tidak dapat memuat pengaturan pengodean',
  'Could not save coding settings': 'Tidak dapat menyimpan pengaturan pengodean',
  'Food & Beverage': 'Makanan & Minuman',
  'Food purchases': 'Pembelian makanan',
};

export default settings;
